import { ContractConfirmationDto } from "@/@client/Theasoft_ApiServer_Contracts"
import { useDefaultAttachmentsApiForControllerRoute } from "@/attachment-api"
import { ActionIcon, Anchor, HoverCard, Stack } from "@mantine/core"
import { IconContract } from "@tabler/icons-react"

interface Props {
  confirmations: ContractConfirmationDto[]
}

export function ConractHoverCard({ confirmations }: Props) {
  const attachmentApi = useDefaultAttachmentsApiForControllerRoute(
    "contracts/contract-documents"
  )
  const attachmentLinks = confirmations
    .filter((confirmation) => confirmation.validityStatus === "Valid")
    .flatMap((confirmation) =>
      confirmation.contractDocumentAttachments.flatMap(
        (contractDocumentAttachment) => (
          <Anchor
            key={contractDocumentAttachment.attachmentId}
            href={attachmentApi.getFileUrl(
              contractDocumentAttachment.attachmentId,
              contractDocumentAttachment.containerId
            )}
            target="_blank"
          >
            {`${confirmation.documentNo ? `${confirmation.documentNo}: ` : ""}${contractDocumentAttachment.attachmentName}`}
          </Anchor>
        )
      )
    )

  if (attachmentLinks.length === 0) return null

  return (
    <HoverCard>
      <HoverCard.Target>
        <ActionIcon>
          <IconContract />
        </ActionIcon>
      </HoverCard.Target>
      <HoverCard.Dropdown>
        <Stack gap={"xs"}>{attachmentLinks}</Stack>
      </HoverCard.Dropdown>
    </HoverCard>
  )
}
